// Медиа и аватары кампании: типы ассетов/аватаров и методы загрузки, генерации, получения контента.
// Вынесено из api.ts (Фаза 1, разбор клиента по доменам).

import { request, requestBlob, LONG_ACTION_TIMEOUT_MS, MEDIA_REQUEST_TIMEOUT_MS } from "./client";

export type CampaignAvatarCode =
  | "TOWER"
  | "SUN"
  | "MOON"
  | "KEY"
  | "COMPASS"
  | "FLAME"
  | "LEAF"
  | "WAVE"
  | "STAR"
  | "GEAR"
  | "QUILL"
  | "CROWN";
export type CampaignAvatarKind = "TELEGRAM" | "CUSTOM" | "INITIALS";
export interface MediaAsset {
  id: string;
  assetType: "NARRATIVE_IMAGE" | "DOCUMENT_IMAGE";
  status: "PENDING" | "GENERATING" | "RETRY" | "READY" | "FAILED";
  mimeType?: string;
  attempts: number;
  nextAttemptAt: string;
  createdAt: string;
  visualCanonVersion: number;
  regenerationCount: number;
}
export type CampaignAvatarGenerationSource =
  "CUSTOM_SELFIE" | "TELEGRAM_PHOTO" | "NONE";
export interface CampaignAvatarGeneration {
  enabled: boolean;
  available: boolean;
  source: CampaignAvatarGenerationSource;
  updatedAt?: string;
  hint: string;
}
export type CampaignAvatarStyleStatus = "NONE" | "QUEUED" | "READY" | "FAILED";
export interface CampaignAvatar {
  kind: CampaignAvatarKind;
  telegramUrl?: string;
  updatedAt?: string;
  styleStatus?: CampaignAvatarStyleStatus;
}

export const mediaApi = {
  uploadCampaignAvatar: (campaignId: string, file: File) => {
    const body = new FormData();
    body.append("file", file);
    return request<{ avatar: CampaignAvatar; generation?: CampaignAvatarGeneration }>(
      `/api/campaigns/${campaignId}/avatars/me`,
      { method: "POST", body },
      MEDIA_REQUEST_TIMEOUT_MS,
    );
  },
  resetCampaignAvatar: (campaignId: string) =>
    request<{ avatar: CampaignAvatar; generation?: CampaignAvatarGeneration }>(
      `/api/campaigns/${campaignId}/avatars/me`,
      { method: "DELETE" },
    ),
  updateAvatarGeneration: (campaignId: string, enabled: boolean) =>
    request<CampaignAvatarGeneration>(
      `/api/campaigns/${campaignId}/avatars/me/generation`,
      { method: "PUT", body: JSON.stringify({ enabled }) },
    ),
  campaignAvatarContent: (campaignId: string, memberId: string) =>
    requestBlob(`/api/campaigns/${campaignId}/avatars/${memberId}/content`),
  worldOpeningImageContent: (campaignId: string, assetId: string) =>
    requestBlob(`/api/campaigns/${campaignId}/world/images/${assetId}/content`),
  cycleImageContent: (campaignId: string, assetId: string) =>
    requestBlob(
      `/api/campaigns/${campaignId}/cycles/images/${assetId}/content`,
    ),
  regenerateWorldImage: (campaignId: string, assetId: string) =>
    request<MediaAsset>(
      `/api/campaigns/${campaignId}/world/images/${assetId}/regenerate`,
      { method: "POST" },
      LONG_ACTION_TIMEOUT_MS,
    ),
  regenerateCycleImage: (campaignId: string, assetId: string) =>
    request<MediaAsset>(
      `/api/campaigns/${campaignId}/cycles/images/${assetId}/regenerate`,
      { method: "POST" },
      LONG_ACTION_TIMEOUT_MS,
    ),
};
